<nav class="pf-nav" aria-label="Navegacion principal">
  <a
    class="pf-nav__item"
    routerLink="/oportunidades"
    routerLinkActive="pf-nav__item--active"
    data-tooltip="Oportunidades"
    aria-label="Oportunidades"
  >
    <span class="pf-nav__icon-shell" aria-hidden="true">
      <svg class="pf-nav__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
        <circle cx="12" cy="12" r="9"/>
        <path d="M12 8v4l3 3"/>
        <path d="M16.5 7.5l-1 1"/>
        <path d="M7.5 7.5l1 1"/>
        <circle cx="12" cy="12" r="1" fill="currentColor" stroke="none"/>
      </svg>
    </span>
  </a>

  <a
    class="pf-nav__item"
    routerLink="/seguimiento"
    routerLinkActive="pf-nav__item--active"
    data-tooltip="Seguimiento"
    aria-label="Seguimiento"
  >
    <span class="pf-nav__icon-shell" aria-hidden="true">
      <svg class="pf-nav__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
        <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7z"/>
        <circle cx="12" cy="12" r="3"/>
      </svg>
    </span>
  </a>
</nav>
